module.exports = __webpack_public_path__ + "img/LogoWobz.54cc120a.svg";